export const TranslateComponentWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div css={{ display: 'flex', alignItems: 'center', margin: '10px 0' }}>{children}</div>
}
